import { IHttpAPI } from './http.types'
import { HttpRequest } from './http.request'

export class HttpUploaderRequest extends HttpRequest implements IHttpAPI {
  constructor() {
    super('')
  }
}
